import { useCallback } from 'react';
import type { GaussianBlurValue } from '../../lib/filters/gaussian-blur';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Gaussian Blur panel — one slider for radius. Capped at 100 in
 *  the UI; the math handles larger values but at 100 a 768px-bounded
 *  preview already runs ~200ms/frame on mid-range laptops, and users
 *  reaching for "more than 100px of blur" usually want a different
 *  filter (or to scale down their image first). */
export function GaussianBlurPanel({ value, onChange }: AdjustmentPanelProps<GaussianBlurValue>) {
  const set = useCallback(
    (patch: Partial<GaussianBlurValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );

  return (
    <div className="space-y-3">
      <RangeRow
        label="Radius"
        min={0}
        max={100}
        step={1}
        value={value.radius}
        onChange={(v) => set({ radius: v })}
      />
    </div>
  );
}
